<template>
  <v-app>
    <core-app-bar />
    <core-drawer />
    <core-view />
    <core-footer />
  </v-app>
</template>

<script>
  export default {
    components: {
      CoreDrawer: () => import('@/vue_files/components/core/Drawer'),
      CoreFooter: () => import('@/vue_files/components/core/Footer'),
      CoreAppBar: () => import('@/vue_files/components/core/AppBar'),
      CoreView: () => import('@/vue_files/components/core/View'),
    },
    beforeMount () {
      let stripeScript = document.createElement('script')
      stripeScript.setAttribute('src', 'https://js.stripe.com/v3/buy-button.js')
      document.head.appendChild(stripeScript)
    },
  }
</script>

<style scoped>
.cookie-options {
  display: flex;
  flex-direction: row; /* Align children horizontally */
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1024px; /* Max width can be adjusted as needed */
  margin: auto;
}

.cookie-option {
  display: flex;
  flex-direction: column; /* Stack toggle and label vertically */
  align-items: center; /* Center align the flex items */
  margin: 10px; /* Space between cookie options */
}

.Cookie__button {
  background-color: rgb(106, 189, 206);
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  min-width: 150px; /* Set a min-width for all buttons */
}

.Cookie__button:hover {
  background-color: rgb(87, 174, 137); /* Darker shade on hover */
}

.toggle-switch {
  width: 40px;
  height: 20px;
  background-color: black; /* Default background for toggle off */
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  margin-top: 5px; /* Space between button and toggle */
}

.toggle-knob {
  width: 18px;
  height: 18px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 1px; /* Start on the left side (off position) */
  transition: all 0.3s ease;
}

.toggle-knob.on {
  left: 21px; /* Move to the right side for the on position */
  background-color: rgb(127, 197, 101); /* Indicate the on state */
}

.close-banner {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  background: none;
  border: none;
  color: white;
}

.close-banner {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  background: none;
  border: none;
  color: white;
}

.modal {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.Cookie, .Cookie--mytheme {
  background-color: rgb(245, 197, 66); /* Red background for the banner */
  color: white; /* White text for visibility */
}
</style>
